<template>
    <div>
        <el-container>
            <el-header>
               <el-row :gutter="20">
                   <el-col :span="8">
                       <div class="grid-content bg-purple">
                           <el-avatar :size="60" src="https://empty" @error="errorHandler">
                               <img src="http://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"/>
                           </el-avatar>
                        </div>
                   </el-col>
                  <el-col :span="16">
                      <div class="grid-content bg-purple">demo简介</div>
                  </el-col>
               </el-row>
            </el-header>


            <el-container>
                <el-aside width="200px">
                    <el-menu :default-openeds="['1', '3']">
                        <el-menu-item index="0">
                            <link-p link="/IntroduceP">简介</link-p>
                        </el-menu-item>
                        <el-submenu index="1">
                            <template slot="title"><i class="el-icon-message"></i>技能</template>
                            <el-menu-item-group>
                                <template slot="title">前端</template>
                                <el-menu-item index="1-1">Javasctiipt</el-menu-item>
                                <el-menu-item index="1-2">Vue</el-menu-item>

                            </el-menu-item-group>
                            <el-menu-item-group title="后端">
                                <el-menu-item index="1-3">Java</el-menu-item>
                            </el-menu-item-group>
                            <el-submenu index="1-4">
                                <template slot="title">选项4</template>
                                <el-menu-item index="1-4-1">选项4-1</el-menu-item>
                            </el-submenu>
                        </el-submenu>
                        <el-submenu index="2">
                            <template slot="title"><i class="el-icon-menu"></i>项目介绍</template>
                            <el-menu-item-group>
                                <template slot="title">WEB</template>
                                <el-menu-item index="2-1">背单词</el-menu-item>
                                <el-menu-item index="2-2"> <link-p link="/IntroudeceEditorP">富文本</link-p></el-menu-item>
                                <el-menu-item index="2-3">购物街</el-menu-item>
                            </el-menu-item-group>
                            <el-menu-item-group title="分组2">
                                <el-menu-item index="2-3">选项3</el-menu-item>
                            </el-menu-item-group>
                            <el-submenu index="2-4">
                                <template slot="title">选项4</template>
                                <el-menu-item index="2-4-1">选项4-1</el-menu-item>
                            </el-submenu>
                        </el-submenu>
                        <el-submenu index="3">
                            <template slot="title"><i class="el-icon-setting"></i>评价</template>
                            <el-menu-item-group>
                                <template slot="title">分组一</template>
                                <el-menu-item index="3-1">选项1</el-menu-item>
                                <el-menu-item index="3-2">选项2</el-menu-item>
                            </el-menu-item-group>
                            <el-menu-item-group title="分组2">
                                <el-menu-item index="3-3">选项3</el-menu-item>
                            </el-menu-item-group>
                            <el-submenu index="3-4">
                                <template slot="title">选项4</template>
                                <el-menu-item index="3-4-1">选项4-1</el-menu-item>
                            </el-submenu>
                        </el-submenu>
                    </el-menu>
                </el-aside>
                <el-main>
                    <router-view></router-view>
                </el-main>
            </el-container>
<!--            <el-footer>Footer</el-footer>-->
        </el-container>
    </div>
</template>

<script>
    import LinkP from "../../link/LinkP";
    export default {
        name: "MyselfP",
        components: {LinkP},
        data() {
            return {
                fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
                url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
            }
        },
        methods: {
            errorHandler() {
                return true
            }
        }
    }
</script>

<style scoped>
    .el-header, .el-footer {
        background-color: #B3C0D1;
        color: #333;
        text-align: center;
        line-height: 60px;
    }

    .el-aside {
        background-color: #D3DCE6;
        color: #333;
        text-align: center;
        line-height: 200px;
    }

    .el-main {
        background-color: #E9EEF3;
        color: #333;
        text-align: center;
        /*line-height: 160px;*/
    }
    .sdf{
        margin-left: 5px;
        height: 30px;
        font-size: 35px;
    }

    body > .el-container {
        margin-bottom: 40px;
    }

    .el-container:nth-child(5) .el-aside,
    .el-container:nth-child(6) .el-aside {
        line-height: 460px;
    }

    .el-container:nth-child(7) .el-aside {
        line-height: 320px;
    }
</style>